module.exports = __webpack_public_path__ + "static/media/filterColumnsModal.0941d6f3.svg";